"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _phaser = require("phaser");

var _phaser2 = _interopRequireDefault(_phaser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _class = function () {
  function _class(game, data) {
    _classCallCheck(this, _class);

    this.game = game;
    this.data = data;

    this.id = data.id;
    this.prereqs = data.prereqs;

    this.enabled = false;
    this.completed = false;

    this.onCompleteSignal = new _phaser2.default.Signal();
  }

  _createClass(_class, [{
    key: "onEnable",
    value: function onEnable() {
      this.enabled = true;

      console.log("enabled " + this.id);
    }
  }, {
    key: "onComplete",
    value: function onComplete() {
      console.log("completed " + this.id);

      this.completed = true;
      this.onCompleteSignal.dispatch(this);
    }
  }]);

  return _class;
}();

exports.default = _class;


//////////////////
// WEBPACK FOOTER
// ./src/story/StoryAction.js
// module id = 12
// module chunks = 0